import { ReportDashboardColumnChooserDialogComponent } from './report-dashboard-column-chooser-dialog.component';
import { ReportDashboardQueryFilterComponent } from './query-filter/report-dashboard-query-filter.component';
import { AppConfig } from './../../app.config';
import {
    SyntheticReportColumn,
    ReportDashboardPresetDefinition,
    ReportDashboardPersistedConfig,
    ReportDashboardMetricDefinition,
    UserProfileReporting,
    ReportDashboardPresetOption,
    ReportDashboardQueryUsage,
    BenchmarkRule,
    ReportDashboardQueryType,
} from '@liquitics/transaction';
import { SelectItem } from 'primeng/api';
import * as moment from 'moment';
import { Component, OnInit, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import {
    convertFromConstantToHuman,
    ReportDashboardQueryRequest,
    QueryFilterOperator,
    QueryFilter,
    ReportDashboardComponentConfig,
    stringOrArrayAsArray,
    ReportDashboardFieldDisplay,
    ReportDashboardQueryHistoricalParams,
    FinancialDate,
    convertFromHumanToCamel,
    ReportDashboardColumnMeta,
} from '@liquitics/transaction';
import { FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { AwsUtil } from '../../authentication/aws.service';
import { SelectionModel } from '@angular/cdk/collections';
import { ChooserBarComponent } from '../../common/chooser-bar/chooser-bar.component';
import { MatCheckboxChange } from '@angular/material/checkbox';

// function componentTypeConditionallyRequiredValidator(requiredForComponentTypes: string[]) {
//     return (formControl: AbstractControl) => {
//         const componentTypeControl = formControl.get('componentType');
//         if (componentTypeControl && requiredForComponentTypes.includes(componentTypeControl.value)) {
//             return Validators.required(formControl);
//         }
//         return null;
//     };
// }

function selectedColumnsValidator(component: ReportDashboardQueryRequestComponent) {
    return (formGroup: FormGroup) => {
        const usage = formGroup.get('queryUsage').value;
        const usePreset = formGroup.get('usePreset').value;
        const componentType = formGroup.get('componentType').value;
        const queryType = formGroup.get('queryType').value;
        if (component.queryFormGroup) {
            // Don't invoke if not initiallized yet
            component.updateMaxAttributes(usage, componentType, queryType);
        }
        if (usePreset) {
            if (!formGroup.get('presetDefinition').value) {
                return { presetDefinition: true };
            }
            return null;
        }
        if (componentType === 'PIVOT') {
            const pivotRowColumnsValue = formGroup.get('pivotRowColumns').value;
            const pivotColColumnsValue = formGroup.get('pivotColColumns').value;
            const valueColumnsValue = formGroup.get('valueColumns').value;
            if (!pivotRowColumnsValue || pivotRowColumnsValue.length === 0) {
                return { pivotRowColumns: true };
            }
            if (!pivotColColumnsValue || pivotColColumnsValue.length === 0) {
                return { pivotColColumns: true };
            }
            if (!valueColumnsValue || valueColumnsValue.length === 0) {
                return { valueColumns: true };
            }
            if (pivotRowColumnsValue.length + pivotColColumnsValue.length > component.maxAttributes) {
                return { maxPivotAttributes: true };
            }
            if (pivotRowColumnsValue
                .filter((rowCol) => {
                    return pivotColColumnsValue.includes(rowCol);
                }).length > 0) {
                return { duplicatePivotAttributes: true };
            }
            if (pivotRowColumnsValue
                .filter((rowCol) => {
                    return (component.availableAttributeColumns && !component.availableAttributeColumns.map(c => c.value).includes(rowCol));
                }).length > 0) {
                return { invalidColumn: true };
            }
            if (pivotColColumnsValue
                .filter((colCol) => {
                    return (component.availableAttributeColumns && !component.availableAttributeColumns.map(c => c.value).includes(colCol));
                }).length > 0) {
                return { invalidColumn: true };
            }
            if (valueColumnsValue
                .filter((valCol) => {
                    return (component.availableValueColumns && !component.availableValueColumns.map(c => c.value).includes(valCol));
                }).length > 0) {
                return { invalidColumn: true };
            }
        } else if (componentType === 'TABLE' || componentType === 'COMPARISON_TABLE') {
            const attributeColumnsValue = formGroup.get('attributeColumns').value;
            const valueColumnsValue = formGroup.get('valueColumns').value;
            if (!attributeColumnsValue || attributeColumnsValue.length === 0) {
                return { attributeColumns: true };
            }
            if (attributeColumnsValue.length > component.maxAttributes) {
                return { attributeColumnsMax: true };
            }
            if (!valueColumnsValue || valueColumnsValue.length === 0) {
                return { valueColumns: true };
            }
            if (valueColumnsValue.length > component.maxValues) {
                return { valueColumnsMax: true };
            }
            if (attributeColumnsValue
                .filter((attribCol) => {
                    return (component.availableAttributeColumns && !component.availableAttributeColumns.map(c => c.value).includes(attribCol));
                }).length > 0) {
                return { invalidColumn: true };
            }
            if (valueColumnsValue
                .filter((valCol) => {
                    return (component.availableValueColumns && !component.availableValueColumns.map(c => c.value).includes(valCol));
                }).length > 0) {
                return { invalidColumn: true };
            }
        } else if (componentType === 'CHART') {
            const attributeColumnValue = formGroup.get('attributeColumn').value;
            const valueColumnValue = formGroup.get('valueColumn').value;
            if (!attributeColumnValue || attributeColumnValue.length === 0) {
                return { attributeColumn: true };
            }
            if (!valueColumnValue || valueColumnValue.length === 0) {
                return { valueColumn: true };
            }
            if (component.availableAttributeColumns && !component.availableAttributeColumns.map(c => c.value).includes(attributeColumnValue)) {
                return { invalidColumn: true };
            }
            if (component.availableValueColumns && !component.availableValueColumns.map(c => c.value).includes(valueColumnValue)) {
                return { invalidColumn: true };
            }
        } else if (componentType === 'TEXT') {
        }
        const fieldDisplays = component.reportDashboardComponentConfig.fieldDisplays || [];
        let returnValue = null;
        fieldDisplays
            .forEach((fd) => {
                if (fd.totalType === 'RUNNING_TOTAL') {
                    const result = component.isRunningTotalSupported(fd.field);
                    if (!result.isSupported) {
                        returnValue = { invalidFieldDisplay: result.message };
                    }
                }
            });
        return returnValue;
    };
}

interface PresetChoice {
    label: string;
    value: ReportDashboardPresetDefinition;
}

interface PresetChoiceGroup {
    groupName: string;
    presetChoices: PresetChoice[];
}

interface PresetOptionAndValue {
    option: ReportDashboardPresetOption;
    value: any;
    selectItems?: SelectItem[];
}

interface PresetOptionAndValuesGroup {
    name: string;
    optionAndValues: PresetOptionAndValue[];
}

@Component({
    selector: 'app-report-dashboard-query-request',
    templateUrl: './report-dashboard-query-request.component.html',
    styleUrls: ['./report-dashboard-query-request.component.scss'],
    providers: [
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    ],
})
export class ReportDashboardQueryRequestComponent implements OnInit, AfterViewInit {
    columnMeta: ReportDashboardColumnMeta[];
    customerColumnAliases: { [key: string]: string };
    metricDefinitions: ReportDashboardMetricDefinition[];
    benchmarkRules: BenchmarkRule[];
    availableAttributeColumns: SelectItem[];
    availableValueColumns: SelectItem[];

    sourceQueryFilterColumnGroups: SelectItem[][];
    resultQueryFilterColumnGroups: SelectItem[][];

    availablePresetChoiceGroups: PresetChoiceGroup[];
    allMetricChoices: SelectItem[];
    metricDefinitionUsableMetricChoices: SelectItem[];
    benchmarkChoices: SelectItem[];
    title: string;
    okButtonLabel = 'Ok';
    designers: string[];
    license: any;

    allowedQueryTypes: SelectItem[];
    maxAttributes: number;
    maxValues: number;
    maxLimitRows: number;

    currentColumnSources: string[];


    reportDashboardPersistedConfig: ReportDashboardPersistedConfig;
    reportDashboardComponentConfig: ReportDashboardComponentConfig;
    reportDashboardMetricDefinition: ReportDashboardMetricDefinition;
    isReportDashboardComponentConfig: boolean;
    queryRequest: ReportDashboardQueryRequest;
    queryFormGroup: FormGroup;
    distinctValues: { [columnName: string]: string[] } = {};
    systemSyntheticReportColumns: SyntheticReportColumn[];
    presetDefinitions: ReportDashboardPresetDefinition[];

    selectedPresetOptionAndValuesGroups: PresetOptionAndValuesGroup[];
    selectedFieldDisplay: ReportDashboardFieldDisplay;

    showQueryUsage: boolean;

    queryUsageDisabled = false;
    componentTypeDisabled = false;
    sourceFiltersDisabled = false;
    resultFiltersDisabled = false;
    fieldDisplaysDisabled = false;
    componentDisplaysDisabled = false;
    displayExtraOptionsDisabled = false;
    additionalOptionsDisabled = false;
    presetOptionsDisabled = true;
    permissionsDisabled = true;
    conditionalityDisabled = true;

    // @ViewChild('sourceFilterTable', { static: false }) sourceFilterTable: MatTable<QueryFilter>;
    // @ViewChild('resultFilterTable', { static: false }) resultFilterTable: MatTable<QueryFilter>;

    @ViewChild('sourceFilterComponent', { static: true }) sourceFilterComponent: ReportDashboardQueryFilterComponent;
    @ViewChild('resultFilterComponent', { static: true }) resultFilterComponent: ReportDashboardQueryFilterComponent;


    bucketTenorChooserBar: ChooserBarComponent;
    @ViewChild('bucketTenorChooserBar', { static: false }) set content(cb: ChooserBarComponent) {
        if (cb) {
            this.bucketTenorChooserBar = cb;
            this.bucketTenorChooserBar.registerOnChange((i: any) => {
                this.selectedFieldDisplay.bucketTenors = this.bucketTenorChooserBar.value;
            });
        }
    }

    findPresetDefinition(presetDefinitions: ReportDashboardPresetDefinition[], presetType: string) {
        return (presetDefinitions || [])
            .find((pd) => {
                return pd.name === presetType;
            });
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialog: MatDialog,
        private appConfig: AppConfig,
        private awsUtil: AwsUtil) {
        let componentType;
        let chartType;
        let pivotRowColumns;
        let pivotColColumns;
        let attributeColumn;
        let attributeColumns;
        let valueColumn;
        let valueColumns;
        this.distinctValues = data.distinctValues;
        this.systemSyntheticReportColumns = data.systemSyntheticReportColumns;
        this.columnMeta = data.columnMeta;
        this.reportDashboardPersistedConfig = data.reportDashboardPersistedConfig;
        this.reportDashboardComponentConfig = data.configuration;
        this.presetDefinitions = data.presetDefinitions || [];
        this.designers = data.designers;
        this.metricDefinitions = data.metricDefinitions;
        this.benchmarkRules = data.benchmarkRules;

        if (data.isMetricDefinition) {
            this.reportDashboardMetricDefinition = this.reportDashboardPersistedConfig as ReportDashboardMetricDefinition;
        }

        const reportingProfile: UserProfileReporting = this.appConfig.activeUserProfile as UserProfileReporting;
        this.license = reportingProfile.getLicense();

        this.updateAvailablePresetChoices();

        this.allowedQueryTypes = [
            { value: 'TRADE', label: 'Trade' },
            { value: 'CASH_FLOW', label: 'Cash Flow' },
            { value: 'IRS_POSITION', label: 'IRS' },
            { value: 'LCR_POSITION', label: 'LCR' },
            { value: 'NSFR_POSITION', label: 'NSFR' },
            { value: 'DURATION_POSITION', label: 'Duration' },
            { value: 'SLS_POSITION', label: 'SLS' },
            { value: 'FTP_ADVANCES_POSITION', label: 'FTP Advances' },
            { value: 'SBSE_POSITION', label: 'SBSE' },
        ].filter((queryTypeItem) => {
            return (this.license?.dashboard?.queryTypes || []).includes(queryTypeItem.value) || queryTypeItem.value === 'SBSE_POSITION';
        })

        this.queryRequest = this.reportDashboardComponentConfig.queryRequest;
        this.isReportDashboardComponentConfig = true;
        componentType = this.reportDashboardComponentConfig.type;
        if (componentType === 'TEXT') {
            // Tack on a dummy query request as the entire component relies of there being a query request
            this.queryRequest = {} as ReportDashboardQueryRequest;
            this.reportDashboardComponentConfig.queryRequest = this.queryRequest;
            // This will be stripped at end
        }
        if (componentType === 'CHART' && this.reportDashboardComponentConfig.chart) {
            chartType = this.reportDashboardComponentConfig.chart.chartType;
            if (this.queryRequest.attributeColumns) {
                attributeColumn = this.queryRequest.attributeColumns[0];
            }
            if (this.queryRequest.valueColumns) {
                valueColumn = this.queryRequest.valueColumns[0];
            }
        }
        if (componentType === 'PIVOT' && this.reportDashboardComponentConfig.pivot) {
            pivotRowColumns = this.reportDashboardComponentConfig.pivot.rowAttributes;
            pivotColColumns = this.reportDashboardComponentConfig.pivot.colAttributes;
            valueColumns = this.reportDashboardComponentConfig.pivot.sumAttributes;
        }
        if (componentType === 'TABLE' || componentType === 'COMPARISON_TABLE') {
            attributeColumns = this.queryRequest.attributeColumns;
            valueColumns = this.queryRequest.valueColumns;
        }
        if (componentType === 'METRIC') {
            if (this.queryRequest.valueColumns) {
                valueColumns = this.queryRequest.valueColumns;
            }
        }
        // Fix up possible missing default and undefineds
        if (!this.reportDashboardComponentConfig.fieldDisplays) {
            this.reportDashboardComponentConfig.fieldDisplays = [];
        }
        if (!this.queryRequest.sourceFilters) {
            this.queryRequest.sourceFilters = [];
        }
        if (!this.queryRequest.resultFilters) {
            this.queryRequest.resultFilters = [];
        }
        if (!this.queryRequest.historicalParams) {
            this.queryRequest.historicalParams = {
            } as ReportDashboardQueryHistoricalParams;
        }

        this.title = data.title;
        if (data.okButtonLabel) {
            this.okButtonLabel = data.okButtonLabel;
        }
        this.maxAttributes = 3;
        this.maxValues = 3;
        this.maxLimitRows = 100;

        let histNumPointsValue;
        if (this.queryRequest.historicalParams?.numberOfPointsType === 'NUMBER') {
            histNumPointsValue = `${this.queryRequest.historicalParams?.numberOfPoints}`;
        } else {
            histNumPointsValue = this.queryRequest.historicalParams?.numberOfPointsType;
        }

        if (!this.reportDashboardComponentConfig.conditionalRelevanceConfig) {
            this.reportDashboardComponentConfig.conditionalRelevanceConfig = {
                requirementType: 'ALL',
                conditionRequirements: []
            }
        }

        this.queryFormGroup = new FormGroup({
            'queryName': new FormControl(this.queryRequest.name, [
                Validators.required,
                Validators.maxLength(64),
            ]
            ),
            'queryType': new FormControl(this.queryRequest.type, [
                Validators.required,
            ]
            ),
            'queryUsage': new FormControl(this.queryRequest.usage, [
                Validators.required,
            ]
            ),
            'attributeColumn': new FormControl(attributeColumn, [
            ]
            ),
            'attributeColumns': new FormControl(attributeColumns, [
            ]
            ),
            'valueColumn': new FormControl(valueColumn, [
            ]
            ),
            'valueColumns': new FormControl(valueColumns, [
            ]
            ),
            'sortByColumn': new FormControl(this.queryRequest.sortByColumn, [
            ]
            ),
            'sortDirection': new FormControl((this.queryRequest.sortDescending ? 'DESC' : 'ASC'), [
            ]
            ),
            'useAbsoluteValue': new FormControl(this.queryRequest.useAbsoluteValue, [
            ]
            ),
            'topNCount': new FormControl(this.queryRequest.topNCount, [
            ]
            ),
            'componentType': new FormControl(componentType, [
            ]
            ),
            'chartType': new FormControl(chartType, [
            ]
            ),
            'pivotRowColumns': new FormControl(pivotRowColumns, [
            ]
            ),
            'pivotColColumns': new FormControl(pivotColColumns, [
            ]
            ),
            'headerText': new FormControl(this.reportDashboardComponentConfig?.headerText, [
            ]
            ),
            'footerText': new FormControl(this.reportDashboardComponentConfig?.footerText, [
            ]
            ),
            'useFullWidth': new FormControl(this.reportDashboardComponentConfig?.options?.fullWidth, [
            ]
            ),
            'fillerColspan': new FormControl(this.reportDashboardComponentConfig?.options?.fillerColspan, [
            ]
            ),
            'textScaling': new FormControl(this.reportDashboardComponentConfig?.options?.textScaling, [
            ]
            ),
            'aspectRatio': new FormControl(this.reportDashboardComponentConfig?.aspectRatio, [
            ]
            ),
            'comparisonDateType': new FormControl(this.queryRequest.historicalParams.comparisonDateType, [
            ]
            ),
            'comparisonDate': new FormControl(this.queryRequest.historicalParams.comparisonDate ? moment.utc(this.queryRequest.historicalParams.comparisonDate) : undefined, [
            ]
            ),
            'historicalFrequency': new FormControl(this.queryRequest.historicalParams.frequency ? this.queryRequest.historicalParams.frequency : undefined, [
            ]
            ),
            'usePreset': new FormControl((this.queryRequest.presetConfig !== undefined), [
            ]
            ),
            'presetDefinition': new FormControl(this.findPresetDefinition(this.presetDefinitions, this.queryRequest.presetConfig?.type), [
            ]
            ),
            'historicalSpecificDates': new FormControl(this.queryRequest.historicalParams.specificDates, [
            ]
            ),
            'historicalNumberOfPoints': new FormControl(histNumPointsValue, [
            ]
            ),
            'historicalAlwaysIncludeOperatingDate': new FormControl(this.queryRequest.historicalParams.alwaysIncludeOperatingDate, [
            ]
            ),
            'conditionalityRequirementType': new FormControl(this.reportDashboardComponentConfig.conditionalRelevanceConfig.requirementType, [
            ]
            ),
            'fieldDisplay': new FormControl(this.selectedFieldDisplay, [
            ]
            ),
        }, selectedColumnsValidator(this));
        this.showQueryUsage = data.showQueryUsage;
        this.updateCurrentColumnSources();
        this.updateColumnChoices();
        this.updateSourceQueryFilterColumnGroups();
        this.updateResultQueryFilterColumnGroups();
    }

    ngOnInit() {
        this.sourceFilterComponent.setQueryFilters(this.queryRequest.sourceFilters || []);
        this.resultFilterComponent.setQueryFilters(this.queryRequest.resultFilters || []);
        if (this.queryRequest.presetConfig) {
            // Reapply preset settings to handle cases where preset definitions have changed
            const foundPresetDefinition = this.findPresetDefinition(this.presetDefinitions, this.queryRequest.presetConfig.type);
            if (foundPresetDefinition) {
                this.updateToLatestPresetDefinitions(foundPresetDefinition);
            }
        }
        this.setPresetStructuralAttributes();
        this.updateMaxAttributes(this.queryRequest.usage, this.reportDashboardComponentConfig.type, this.queryRequest.type);
        this.queryFormGroup.updateValueAndValidity();
    }


    ngAfterViewInit() {
    }
    addFormControl(name: string, fg: FormGroup): void {
        this.queryFormGroup.addControl(name, fg);
    }

    get queryName() { return this.queryFormGroup.get('queryName'); }
    get queryType() { return this.queryFormGroup.get('queryType'); }
    get queryUsage() { return this.queryFormGroup.get('queryUsage'); }
    get attributeColumn() { return this.queryFormGroup.get('attributeColumn'); }
    get attributeColumns() { return this.queryFormGroup.get('attributeColumns'); }
    get valueColumn() { return this.queryFormGroup.get('valueColumn'); }
    get valueColumns() { return this.queryFormGroup.get('valueColumns'); }
    get sourceFilterColumn() { return this.queryFormGroup.get('sourceFilterColumn'); }
    get sourceFilterOperator() { return this.queryFormGroup.get('sourceFilterOperator'); }
    get sourceFilterValue() { return this.queryFormGroup.get('sourceFilterValue'); }
    get sourceFilterInValues() { return this.queryFormGroup.get('sourceFilterInValues'); }
    get sourceFilterBetweenValue1() { return this.queryFormGroup.get('sourceFilterBetweenValue1'); }
    get sourceFilterBetweenValue2() { return this.queryFormGroup.get('sourceFilterBetweenValue2'); }
    get resultFilterColumn() { return this.queryFormGroup.get('resultFilterColumn'); }
    get resultFilterOperator() { return this.queryFormGroup.get('resultFilterOperator'); }
    get resultFilterValue() { return this.queryFormGroup.get('resultFilterValue'); }
    get resultFilterBetweenValue1() { return this.queryFormGroup.get('resultFilterBetweenValue1'); }
    get resultFilterBetweenValue2() { return this.queryFormGroup.get('resultFilterBetweenValue2'); }
    get sortByColumn() { return this.queryFormGroup.get('sortByColumn'); }
    get sortDirection() { return this.queryFormGroup.get('sortDirection'); }
    get useAbsoluteValue() { return this.queryFormGroup.get('useAbsoluteValue'); }
    get topNCount() { return this.queryFormGroup.get('topNCount'); }
    get componentType() { return this.queryFormGroup.get('componentType'); }
    get chartType() { return this.queryFormGroup.get('chartType'); }
    get pivotRowColumns() { return this.queryFormGroup.get('pivotRowColumns'); }
    get pivotColColumns() { return this.queryFormGroup.get('pivotColColumns'); }
    get headerText() { return this.queryFormGroup.get('headerText'); }
    get footerText() { return this.queryFormGroup.get('footerText'); }
    get fullWidth() { return this.queryFormGroup.get('useFullWidth'); }
    get fillerColspan() { return this.queryFormGroup.get('fillerColspan'); }
    get textScaling() { return this.queryFormGroup.get('textScaling'); }
    get aspectRatio() { return this.queryFormGroup.get('aspectRatio'); }
    get comparisonDateType() { return this.queryFormGroup.get('comparisonDateType'); }
    get comparisonDate() { return this.queryFormGroup.get('comparisonDate'); }
    get historicalFrequency() { return this.queryFormGroup.get('historicalFrequency'); }
    get usePreset() { return this.queryFormGroup.get('usePreset'); }
    get presetDefinition() { return this.queryFormGroup.get('presetDefinition'); }
    get historicalSpecificDates() { return this.queryFormGroup.get('historicalSpecificDates'); }
    get historicalNumberOfPoints() { return this.queryFormGroup.get('historicalNumberOfPoints'); }
    get historicalAlwaysIncludeOperatingDate() { return this.queryFormGroup.get('historicalAlwaysIncludeOperatingDate'); }
    get owner() { return this.queryFormGroup.get('permissions').get('owner'); }
    get collaborators() { return this.queryFormGroup.get('permissions').get('collaborators'); }
    get viewers() { return this.queryFormGroup.get('permissions').get('viewers'); }
    get conditionalityRequirementType() { return this.queryFormGroup.get('conditionalityRequirementType'); }
    get fieldDisplay() { return this.queryFormGroup.get('fieldDisplay'); }

    toSortedSelectItems(columnMetas: ReportDashboardColumnMeta[]): SelectItem[] {
        return columnMetas
            .map((meta) => {
                const columnName = meta.columnName.toLowerCase();
                const labelToUse = meta.alias || convertFromConstantToHuman(columnName);
                return {
                    label: labelToUse,
                    value: columnName,
                };
            })
            .sort((si1, si2) => {
                return si1.label < si2.label ? -1 : 1;
            });
    }

    filterByCurrentColumnSources(columnMetas: ReportDashboardColumnMeta[]): ReportDashboardColumnMeta[] {
        return columnMetas
            .filter((meta) => {
                return this.currentColumnSources && this.currentColumnSources.includes(meta.source);
            });
    }

    filterForGeneralSystemSyntheticUse(columnMetas: ReportDashboardColumnMeta[]): ReportDashboardColumnMeta[] {
        return columnMetas
            .filter((meta) => {
                if (meta.source === 'SYSTEM_SYNTHETIC') {
                    const foundSRC = this.systemSyntheticReportColumns
                        .find((src) => {
                            return src.columnName === meta.columnName;
                        });
                    if (foundSRC?.meta?.targetQueryTypes) {
                        // For system synthetics that have explicit targets, refer to their defintion
                        return foundSRC?.meta?.targetQueryTypes.includes(this.queryType.value);
                    } else {
                        // For all other system synthetics, assume to scope is meant only for TRADE queries
                        return this.queryType.value === 'TRADE';
                    }
                }
                return true;
            });
    }

    filterForUsage(columnMetas: ReportDashboardColumnMeta[], usage: 'ATTRIBUTE' | 'VALUE'): ReportDashboardColumnMeta[] {
        return columnMetas
            .filter((meta) => {
                return meta.usageType === usage;
            });
    }

    filterForQueryType(columnMetas: ReportDashboardColumnMeta[], queryType: ReportDashboardQueryType): ReportDashboardColumnMeta[] {
        return columnMetas
            .filter((meta) => {
                if (queryType === 'CASH_FLOW') {
                    return meta.source === 'CASH_FLOW' || meta.source === 'SYSTEM_SYNTHETIC';
                } else if (queryType === 'IRS_POSITION') {
                    return meta.source === 'IRS_TRADE_LEVEL' || meta.source === 'SYSTEM_SYNTHETIC';
                } else if (queryType === 'LCR_POSITION') {
                    return meta.source === 'LCR_TRADE_LEVEL' || meta.source === 'SYSTEM_SYNTHETIC';
                } else if (queryType === 'NSFR_POSITION') {
                    return meta.source === 'NSFR_TRADE_LEVEL' || meta.source === 'SYSTEM_SYNTHETIC';
                } else if (queryType === 'DURATION_POSITION') {
                    return meta.source === 'DURATION_TRADE_LEVEL' || meta.source === 'SYSTEM_SYNTHETIC';
                } else if (queryType === 'SLS_POSITION') {
                    return meta.source === 'SLS_TRADE_LEVEL' || meta.source === 'SYSTEM_SYNTHETIC';
                } else if (queryType === 'FTP_ADVANCES_POSITION') {
                    return meta.source === 'FTP_ADVANCES_TRADE_LEVEL' || meta.source === 'SYSTEM_SYNTHETIC';
                } else if (queryType === 'SBSE_POSITION') {
                    return meta.source === 'SBSE_TRADE_LEVEL' || meta.source === 'SYSTEM_SYNTHETIC';
                }
                return true;
            });
    }


    updateColumnChoices() {
        this.customerColumnAliases = this.columnMeta
            .filter((meta) => {
                return meta.alias;
            })
            .reduce((agg, meta) => {
                agg[meta.columnName.toLowerCase()] = meta.alias;
                return agg;
            }, {});
        const filteredColumnMeta = this.filterForGeneralSystemSyntheticUse(this.filterByCurrentColumnSources(this.columnMeta));
        const allAttributeMetas = this.filterForUsage(filteredColumnMeta, 'ATTRIBUTE');
        this.availableAttributeColumns = this.toSortedSelectItems(allAttributeMetas);
        const allValueMetas = this.filterForQueryType(this.filterForUsage(filteredColumnMeta, 'VALUE'), this.queryType.value);
        this.availableValueColumns = this.toSortedSelectItems(allValueMetas);

        this.allMetricChoices = [];
        this.metricDefinitionUsableMetricChoices = [];
        this.metricDefinitions
            .forEach((md) => {
                const choice = {
                    label: `${md.displayName} (${md.identifier})`,
                    value: md.identifier
                };
                this.allMetricChoices.push(choice);
                if (md.type === 'QUERY_BASED' || md.type === 'SYSTEM' || md.type === 'PRESET_BASED') {
                    this.metricDefinitionUsableMetricChoices.push(choice);
                }
            });
        this.presetDefinitions
            .filter((pd: ReportDashboardPresetDefinition) => {
                return pd.category === 'METRIC' && !(pd.meta?.isAbstractDefinition);
            })
            .forEach((pd: ReportDashboardPresetDefinition) => {
                const choice = {
                    label: pd.displayName,
                    value: pd.name
                };
                this.allMetricChoices.push(choice);
                // TBD on if we should include these... (And.. we have now found the need so enabling)
                this.metricDefinitionUsableMetricChoices.push(choice);
            });
        this.benchmarkChoices = (this.benchmarkRules || [])
            .map((benchmarkRule) => {
                return {
                    label: benchmarkRule.name,
                    value: benchmarkRule
                };
            });
        // Preset defined columns
        const presetDefinition: ReportDashboardPresetDefinition = this.presetDefinition.value;
        if (presetDefinition) {
            this.availableAttributeColumns.push(...(presetDefinition.attributeColumns || [])
                .map((column: string) => {
                    return {
                        label: column,
                        value: column,
                    };
                }));
            this.availableValueColumns.push(...(presetDefinition.valueColumns || [])
                .map((column: string) => {
                    return {
                        label: column,
                        value: column,
                    };
                }));
        }
    }

    updateCurrentColumnSources() {
        if (this.queryType.value === 'TRADE') {
            this.currentColumnSources = ['TRADE', 'SYNTHETIC', 'SYSTEM_SYNTHETIC'];
        } else if (this.queryType.value === 'CASH_FLOW') {
            this.currentColumnSources = ['TRADE', 'SYNTHETIC', 'SYSTEM_SYNTHETIC', 'CASH_FLOW'];
        } else if (this.queryType.value === 'IRS_POSITION') {
            this.currentColumnSources = ['TRADE', 'SYNTHETIC', 'SYSTEM_SYNTHETIC', 'IRS_TRADE_LEVEL'];
        } else if (this.queryType.value === 'LCR_POSITION') {
            this.currentColumnSources = ['TRADE', 'SYNTHETIC', 'SYSTEM_SYNTHETIC', 'LCR_TRADE_LEVEL'];
        } else if (this.queryType.value === 'NSFR_POSITION') {
            this.currentColumnSources = ['TRADE', 'SYNTHETIC', 'SYSTEM_SYNTHETIC', 'NSFR_TRADE_LEVEL'];
        } else if (this.queryType.value === 'DURATION_POSITION') {
            this.currentColumnSources = ['TRADE', 'SYNTHETIC', 'SYSTEM_SYNTHETIC', 'DURATION_TRADE_LEVEL'];
        } else if (this.queryType.value === 'SLS_POSITION') {
            this.currentColumnSources = ['TRADE', 'SYNTHETIC', 'SYSTEM_SYNTHETIC', 'SLS_TRADE_LEVEL'];
        } else if (this.queryType.value === 'FTP_ADVANCES_POSITION') {
            this.currentColumnSources = ['TRADE', 'SYNTHETIC', 'SYSTEM_SYNTHETIC', 'FTP_ADVANCES_TRADE_LEVEL'];
        } else if (this.queryType.value === 'SBSE_POSITION') {
            this.currentColumnSources = ['TRADE', 'SYNTHETIC', 'SYSTEM_SYNTHETIC', 'SBSE_TRADE_LEVEL'];
        } else if (this.queryType.value === 'REGISTERED') {
            this.currentColumnSources = ['TRADE', 'SYNTHETIC', 'SYSTEM_SYNTHETIC'];
        }
    }



    updateAvailablePresetChoices() {
        const groupedPresetChoices = this.presetDefinitions
            .filter((pd: ReportDashboardPresetDefinition) => {
                if (this.data.isMetricDefinition) {
                    return pd.category === 'METRIC' && pd.meta?.isAbstractDefinition;
                } else {
                    return pd.category === 'COMPONENT';
                }
            })
            .reduce((grouped, pd: ReportDashboardPresetDefinition) => {
                const key = pd.groupName || 'General';
                grouped[key] = grouped[key] || [];
                grouped[key].push({
                    label: convertFromConstantToHuman(pd.name),
                    value: pd,
                    group: key
                });
                return grouped;
            }, {});
        this.availablePresetChoiceGroups = Object.keys(groupedPresetChoices)
            .map((groupName) => {
                return {
                    groupName,
                    presetChoices: groupedPresetChoices[groupName]
                } as PresetChoiceGroup
            });
    }

    onQueryTypeChange(event) {
        this.updateCurrentColumnSources();
        this.updateColumnChoices();
        this.updateSourceQueryFilterColumnGroups();
        this.updateResultQueryFilterColumnGroups();

        if (this.data.isMetricDefinition) {
            if (this.reportDashboardMetricDefinition.type === 'PRESET_BASED') {
                this.usePreset.setValue(true);
                this.updateAvailablePresetChoices();
            } else {
                this.usePreset.setValue(false);
            }
        }

    }

    onQueryUsageChange(event) {
        this.updateMaxAttributes(this.queryUsage.value, this.componentType.value, this.queryType.value);
        this.queryFormGroup.updateValueAndValidity();
    }

    onUsePresetChange(event) {
        this.updateEnabledDisabled();
        if (!this.usePreset.value) {
            this.presetDefinition.setValue(undefined);
        }
    }

    onUseFullWidthChange(event) {
        if (!this.fullWidth.value) {
            this.fillerColspan.setValue(0);
        }
    }

    updateEnabledDisabled() {
        const presetDefinition: ReportDashboardPresetDefinition = this.presetDefinition.value;
        if (this.usePreset.value && presetDefinition) {
            this.sourceFiltersDisabled = !(presetDefinition.meta?.supportedFeatures?.sourceFilters);
            this.resultFiltersDisabled = !(presetDefinition.meta?.supportedFeatures?.resultFilters);
            this.fieldDisplaysDisabled = !(presetDefinition.meta?.supportedFeatures?.fieldDisplays);
            this.componentDisplaysDisabled = !(presetDefinition.meta?.supportedFeatures?.componentDisplays);
            this.additionalOptionsDisabled = !(presetDefinition.meta?.supportedFeatures?.additionalOptions);
            this.presetOptionsDisabled = false;
        } else {
            this.sourceFiltersDisabled = false;
            this.resultFiltersDisabled = false;
            this.fieldDisplaysDisabled = false;
            this.componentDisplaysDisabled = false;
            this.additionalOptionsDisabled = false;
            this.presetOptionsDisabled = true;
        }
        // Handle Metric Definition Mode
        if (this.data.isMetricDefinition) {
            this.queryUsageDisabled = true;
            this.componentTypeDisabled = true;
            this.resultFiltersDisabled = true;
            this.displayExtraOptionsDisabled = true;
            this.componentDisplaysDisabled = true;
            this.additionalOptionsDisabled = true;
        }
        if (this.reportDashboardPersistedConfig) {
            this.permissionsDisabled = false;
        }
        const userName = this.awsUtil.jwtService.getUserCredentials().getUserName();
        this.conditionalityDisabled = !userName.endsWith('@liquitics.com');
    }

    getGroupedPresetOptions(options?: ReportDashboardPresetOption[]): PresetOptionAndValuesGroup[] {
        let groups: PresetOptionAndValuesGroup[];
        if (options) {
            const selectedPresetOptionAndValues = (options || [])
                .map((option) => {
                    const parameters = this.queryRequest.presetConfig?.parameters || {};
                    const optionValue = parameters[option.name];
                    return {
                        option,
                        value: optionValue
                    } as PresetOptionAndValue;
                });
            selectedPresetOptionAndValues
                .forEach((pov) => {
                    if (pov.option.choiceProvider) {
                        if (pov.option.choiceProvider.columnQueryType) {
                            if (pov.option.choiceProvider.type === 'ATTRIBUTE_COLUMNS') {
                                pov.selectItems = this.toSortedSelectItems(this.filterForQueryType(this.filterForUsage(
                                    this.columnMeta, 'ATTRIBUTE'), pov.option.choiceProvider.columnQueryType));
                            } else if (pov.option.choiceProvider.type === 'VALUE_COLUMNS') {
                                pov.selectItems = this.toSortedSelectItems(this.filterForQueryType(this.filterForUsage(
                                    this.columnMeta, 'VALUE'), pov.option.choiceProvider.columnQueryType));
                            }
                        }
                    }
                });
            const groupedOaVs = selectedPresetOptionAndValues
                .reduce((grouped, oav) => {
                    const groupName = oav.option.group || 'Parameters';
                    grouped[groupName] = grouped[groupName] || [];
                    grouped[groupName].push(oav);
                    return grouped;
                }, {});
            groups = Object.keys(groupedOaVs)
                .map((groupName) => {
                    return {
                        name: groupName,
                        optionAndValues: groupedOaVs[groupName]
                    } as PresetOptionAndValuesGroup
                })
        } else {
            groups = [];
        }
        return groups
    }

    setPresetStructuralAttributes() {
        const presetDefinition: ReportDashboardPresetDefinition = this.presetDefinition.value;
        if (presetDefinition) {
            if ((presetDefinition.meta?.supportedFeatures?.additionalQueryUsages || []).length > 0) {
                this.queryUsageDisabled = false;
            } else {
                this.queryUsageDisabled = true;
            }
            this.queryType.setValue(presetDefinition.queryType);
            this.queryUsage.setValue(presetDefinition.usage);
            this.onQueryTypeChange(event);
            this.onQueryUsageChange(event);
            this.onComponentTypeChange(event);
            this.attributeColumns.setValue(presetDefinition.attributeColumns || []);
            this.valueColumns.setValue(presetDefinition.valueColumns || []);
            this.componentType.setValue((presetDefinition.displayMode === 'CUSTOM') ? 'CUSTOM' : 'TABLE');
            this.selectedPresetOptionAndValuesGroups = this.getGroupedPresetOptions(presetDefinition.options);
        }
        this.updateEnabledDisabled();
    }

    setPresetInitialAttributes() {
        const presetDefinition: ReportDashboardPresetDefinition = this.presetDefinition.value;
        if (presetDefinition) {
            this.sourceFilterComponent.setQueryFilters(presetDefinition.sourceFilters || []);
            this.resultFilterComponent.setQueryFilters(presetDefinition.resultFilters || []);
            this.reportDashboardComponentConfig.fieldDisplays = presetDefinition.fieldDisplays || [];
            this.reinitializeFieldDisplays();
        }
    }

    onPresetChoiceChange(event) {
        this.setPresetStructuralAttributes();
        this.setPresetInitialAttributes();
    }

    updateToLatestPresetDefinitions(presetDefinition: ReportDashboardPresetDefinition) {
        this.queryRequest.type = presetDefinition.queryType;
        this.queryRequest.usage = presetDefinition.usage;
        this.queryRequest.attributeColumns = presetDefinition.attributeColumns;
        this.queryRequest.valueColumns = presetDefinition.valueColumns;
        this.reportDashboardComponentConfig.type = (presetDefinition.displayMode === 'CUSTOM') ? 'CUSTOM' : 'TABLE';
        if (!presetDefinition.meta?.supportedFeatures?.sourceFilters) {
            this.sourceFilterComponent.setQueryFilters(presetDefinition.sourceFilters || []);
        }
        if (!presetDefinition.meta?.supportedFeatures?.resultFilters) {
            this.resultFilterComponent.setQueryFilters(presetDefinition.resultFilters || []);
        }
        if (!presetDefinition.meta?.supportedFeatures?.fieldDisplays) {
            this.reportDashboardComponentConfig.fieldDisplays = presetDefinition.fieldDisplays || [];
            this.reinitializeFieldDisplays();
        }
    }

    onAspectRatioChange(event) {

    }

    availableColumnsCompareWith(v1: string, v2: string): boolean {
        return v1 === v2;
    }

    updateMaxAttributes(usage, componentType, queryType: ReportDashboardQueryType) {
        this.maxLimitRows = 100;
        if (usage === 'GRAPHICAL') {
            this.maxAttributes = 6;
        } else if (usage === 'DOWNLOAD' || usage === 'INVESTIGATION' || usage === 'INVENTORY') {
            this.maxAttributes = 20;
            this.maxValues = 20;
            this.maxLimitRows = 5000;
        } else if (usage === 'DASHBOARD') {
            this.maxAttributes = 6;
            this.maxValues = 6;
            this.maxLimitRows = 100;
            if (componentType === 'TABLE') {
                this.maxAttributes = 20;
                this.maxValues = 15;
                if (this.usePreset.value) {
                    this.maxValues = 16;
                }
               
            }
            if (this.data.publishingConfig?.emailFormat === 'XLSX' && queryType === 'SBSE_POSITION') {
                this.maxValues = 15;
            }
        }
    }

    onChartTypeChange(event) {
    }

    onComponentTypeChange(event) {
        const selectedComponentType = this.componentType.value;
        if (selectedComponentType === 'CHART') {
            if (!this.chartType.value) {
                this.chartType.setValue('PIE');
            }
        } else {
            this.chartType.setValue(undefined);
        }
        if (selectedComponentType === 'COMPARISON_TABLE') {
            if (!this.comparisonDateType.value) {
                this.comparisonDateType.setValue('PREVIOUS_DAY');
                this.comparisonDate.setValue(undefined);
            }
        } else {
            this.comparisonDateType.setValue(undefined);
            this.comparisonDate.setValue(undefined);
        }
        if (selectedComponentType === 'METRIC') {
            this.sourceFiltersDisabled = false;
            this.resultFiltersDisabled = true;
            this.fieldDisplaysDisabled = false;
            this.additionalOptionsDisabled = false;
        } else {
            this.sourceFiltersDisabled = false;
            this.resultFiltersDisabled = false;
            this.fieldDisplaysDisabled = false;
            this.additionalOptionsDisabled = false;
        }
        this.updateSourceQueryFilterColumnGroups();
        this.updateResultQueryFilterColumnGroups();
        this.updateMaxAttributes(this.queryUsage.value, selectedComponentType, this.queryType.value);
        this.queryFormGroup.updateValueAndValidity();
    }


    // onSourceFilterSelect(sf: QueryFilter) {
    //     this.sourceFilterSelection.toggle(sf);
    //     if (this.sourceFilterSelection.isSelected(sf)) {
    //         this.selectedSourceFilter = sf;
    //         this.selectedSourceFilterColumn = sf.attributeColumn;
    //         this.selectedSourceFilterOperator = sf.operator;
    //         this.selectedSourceFilterValue = sf.value;
    //         this.selectedSourceFilterInValues = sf.value?.split(',');
    //         this.selectedSourceFilterBetweenValue1 = sf.value?.split('|')[0];
    //         this.selectedSourceFilterBetweenValue2 = sf.value?.split('|')[1];

    //         this.sourceFilterColumn.setValue(sf.attributeColumn);
    //         this.sourceFilterOperator.setValue(sf.operator);
    //         this.sourceFilterValue.setValue(sf.value);
    //         this.sourceFilterInValues.setValue(sf.value?.split(','));
    //         this.sourceFilterBetweenValue1.setValue(sf.value?.split('|')[0]);
    //         this.sourceFilterBetweenValue2.setValue(sf.value?.split('|')[1]);
    //     } else {
    //         this.selectedSourceFilter = null;
    //         this.selectedSourceFilterColumn = null;
    //         this.selectedSourceFilterOperator = null;
    //         this.selectedSourceFilterValue = null;
    //         this.selectedSourceFilterInValues = null;
    //         this.selectedSourceFilterBetweenValue1 = null;
    //         this.selectedSourceFilterBetweenValue2 = null;
    //     }
    // }

    // onResultFilterSelect(sf: QueryFilter) {
    //     this.resultFilterSelection.toggle(sf);
    //     if (this.resultFilterSelection.isSelected(sf)) {
    //         this.selectedResultFilter = sf;
    //         this.selectedResultFilterColumn = sf.attributeColumn;
    //         this.selectedResultFilterOperator = sf.operator;
    //         this.selectedResultFilterValue = sf.value;
    //         this.selectedResultFilterBetweenValue1 = sf.value?.split('|')[0];
    //         this.selectedResultFilterBetweenValue2 = sf.value?.split('|')[1];

    //         this.resultFilterColumn.setValue(sf.attributeColumn);
    //         this.resultFilterOperator.setValue(sf.operator);
    //         this.resultFilterValue.setValue(sf.value);
    //         this.resultFilterBetweenValue1.setValue(sf.value?.split('|')[0]);
    //         this.resultFilterBetweenValue2.setValue(sf.value?.split('|')[1]);
    //     } else {
    //         this.selectedResultFilter = null;
    //         this.selectedResultFilterColumn = null;
    //         this.selectedResultFilterOperator = null;
    //         this.selectedResultFilterValue = null;
    //         this.selectedResultFilterBetweenValue1 = null;
    //         this.selectedResultFilterBetweenValue2 = null;
    //     }
    // }

    // addSourceFilter(event) {
    //     if (this.sourceFilterColumn && this.sourceFilterOperator &&
    //         (this.sourceFilterValue || (this.sourceFilterBetweenValue1 && this.sourceFilterBetweenValue2))) {
    //         let filterValue;
    //         if (this.sourceFilterOperator.value === 'BETWEEN' || this.sourceFilterOperator.value === 'NOT_BETWEEN') {
    //             filterValue = `${this.sourceFilterBetweenValue1.value}|${this.sourceFilterBetweenValue2.value}`;

    //         } else if ((this.sourceFilterOperator.value === 'IN' || this.sourceFilterOperator.value === 'NOT_IN') &&
    //             (this.distinctValues && this.sourceFilterColumn.value && this.distinctValues[this.sourceFilterColumn.value])) {
    //             filterValue = this.sourceFilterInValues.value?.join(',');
    //         } else {
    //             filterValue = this.sourceFilterValue.value;
    //         }
    //         const newFilter: QueryFilter = {
    //             attributeColumn: this.sourceFilterColumn.value,
    //             operator: this.sourceFilterOperator.value,
    //             value: filterValue,
    //         };
    //         if (!this.queryRequest.sourceFilters.find((filter) => {
    //             return filter.attributeColumn === newFilter.attributeColumn &&
    //                 filter.operator === newFilter.operator &&
    //                 filter.value === newFilter.value;
    //         })) {
    //             this.queryRequest.sourceFilters = [...this.queryRequest.sourceFilters, newFilter];
    //             this.sourceFilterDataSource.data.push(newFilter);
    //         }
    //     }
    //     this.sourceFilterTable.renderRows();
    // }


    // addResultFilter(event) {
    //     if (this.resultFilterColumn && this.resultFilterOperator &&
    //         this.resultFilterValue || (this.resultFilterBetweenValue1 && this.resultFilterBetweenValue2)) {
    //         const filterValue = (this.resultFilterOperator.value === 'BETWEEN' || this.resultFilterOperator.value === 'NOT_BETWEEN') ?
    //             `${this.resultFilterBetweenValue1.value}|${this.resultFilterBetweenValue2.value}` :
    //             this.resultFilterValue.value;
    //         const newFilter: QueryFilter = {
    //             attributeColumn: this.resultFilterColumn.value,
    //             operator: this.resultFilterOperator.value,
    //             value: filterValue,
    //         };
    //         if (!this.queryRequest.resultFilters.find((filter) => {
    //             return filter.attributeColumn === newFilter.attributeColumn &&
    //                 filter.operator === newFilter.operator &&
    //                 filter.value === newFilter.value;
    //         })) {
    //             this.queryRequest.resultFilters = [...this.queryRequest.resultFilters, newFilter];
    //             this.resultFilterDataSource.data.push(newFilter);
    //         }
    //     }
    //     this.resultFilterTable.renderRows();
    // }

    debug() {
        const controls = this.queryFormGroup.controls;
        for (const name in controls) {
            const invalid = controls[name].invalid;
            const value = controls[name].value;
            console.log(`[${name}]: Invalid: ${invalid},Value: ${value}`);
        }
        console.log(JSON.stringify(this.reportDashboardComponentConfig, null, 2));
    }

    setHistoricalParamsForSeries() {
        const frequency = this.historicalFrequency.value;
        const numberOfPointsStr = this.historicalNumberOfPoints.value;
        this.queryRequest.historicalParams.type = 'SERIES';
        this.queryRequest.historicalParams.frequency = frequency;
        this.queryRequest.historicalParams.dayOfMonth = 'NONE';
        if (!frequency || frequency === 'NONE') {
            delete this.queryRequest.historicalParams;
        } else {
            if (frequency === 'SPECIFIC') {
                // Specific dates mode
                this.queryRequest.historicalParams.specificDates = this.historicalSpecificDates.value;
                this.queryRequest.historicalParams.numberOfPointsType = 'SPECIFIC';
                delete this.queryRequest.historicalParams.numberOfPoints;
            } else {
                // Frequency mode
                delete this.queryRequest.historicalParams.specificDates;
                const numberOfPoints = Number.parseInt(numberOfPointsStr, 10);
                if (isNaN(numberOfPoints)) {
                    this.queryRequest.historicalParams.numberOfPointsType = numberOfPointsStr;
                    delete this.queryRequest.historicalParams.numberOfPoints;
                } else {
                    this.queryRequest.historicalParams.numberOfPointsType = 'NUMBER';
                    this.queryRequest.historicalParams.numberOfPoints = numberOfPoints;
                }
            }
            this.queryRequest.historicalParams.alwaysIncludeOperatingDate = this.historicalAlwaysIncludeOperatingDate.value;
        }
    }


    onOKButton() {
        this.queryFormGroup.updateValueAndValidity();
        const invalid = [];
        const controls = this.queryFormGroup.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }

        this.queryRequest.name = this.queryName.value;
        this.queryRequest.type = this.queryType.value;
        this.queryRequest.usage = this.queryUsage.value;
        this.queryRequest.batchIdentifier = this.data.batchIdentifier;
        const isPreset = this.usePreset.value;
        let historicalUsed = false;

        if (this.isReportDashboardComponentConfig) {
            this.reportDashboardComponentConfig.type = this.componentType.value;
            this.reportDashboardComponentConfig.title = this.queryName.value;
            this.reportDashboardComponentConfig.chart = undefined;
            this.reportDashboardComponentConfig.pivot = undefined;
            this.reportDashboardComponentConfig.table = undefined;
            this.reportDashboardComponentConfig.text = undefined;
            // Other stuff
            if (this.reportDashboardComponentConfig.type === 'CHART') {
                this.queryRequest.attributeColumns = [this.attributeColumn.value];
                this.queryRequest.valueColumns = [this.valueColumn.value];
                this.reportDashboardComponentConfig.chart = {
                    chartType: this.chartType.value,
                    xAttribute: this.attributeColumn.value,
                    yAttribute: this.valueColumn.value,
                };
            } else if (this.reportDashboardComponentConfig.type === 'PIVOT') {
                const attributeColumns = [...this.pivotRowColumns.value, ...this.pivotColColumns.value];
                this.queryRequest.attributeColumns = attributeColumns;
                this.queryRequest.valueColumns = this.valueColumns.value;
                this.reportDashboardComponentConfig.pivot = {
                    rowAttributes: this.pivotRowColumns.value,
                    colAttributes: this.pivotColColumns.value,
                    sumAttributes: this.valueColumns.value,
                };
            } else if (this.reportDashboardComponentConfig.type === 'TABLE' ||
                this.reportDashboardComponentConfig.type === 'COMPARISON_TABLE') {
                this.queryRequest.attributeColumns = this.attributeColumns.value;
                this.queryRequest.valueColumns = this.valueColumns.value;
                this.reportDashboardComponentConfig.table = {
                    colAttributes: [...this.queryRequest.attributeColumns, ...this.valueColumns.value],
                    numberAttributes: this.valueColumns.value,
                    includeRowNums: (this.queryRequest.topNCount && this.queryRequest.topNCount > 0)
                };
                if (this.reportDashboardComponentConfig.type === 'COMPARISON_TABLE') {
                    this.queryRequest.historicalParams.type = 'COMPARISON';
                    this.queryRequest.historicalParams.comparisonDateType = this.comparisonDateType.value;
                    if (this.comparisonDateType.value === 'SPECIFIC') {
                        this.queryRequest.historicalParams.comparisonDate = moment.utc(this.comparisonDate.value).format('YYYY-MM-DD');
                    } else {
                        this.queryRequest.historicalParams.comparisonDate = undefined;
                    }
                    historicalUsed = true;
                }
            } else if (this.reportDashboardComponentConfig.type === 'METRIC') {
                this.queryRequest.valueColumns = this.valueColumns.value;
            }
            if (this.isHistoricalSeriesAllowed()) {
                this.setHistoricalParamsForSeries();
                historicalUsed = true;
            }

            if (!historicalUsed) {
                // Clean up historical params if not in use
                delete this.queryRequest.historicalParams;
            }

            this.reportDashboardComponentConfig.options = {
                fullWidth: this.fullWidth.value,
                fillerColspan: this.fillerColspan.value,
                textScaling: this.textScaling.value,
            };
            this.reportDashboardComponentConfig.headerText = this.headerText.value;
            this.reportDashboardComponentConfig.footerText = this.footerText.value;
            this.reportDashboardComponentConfig.aspectRatio = this.aspectRatio.value || 'SQUARE';
        } else {
            this.queryRequest.attributeColumns = this.attributeColumns.value;
            this.queryRequest.valueColumns = this.valueColumns.value;
        }

        this.queryRequest.sourceFilters = this.sourceFilterComponent.getQueryFilters();
        this.queryRequest.resultFilters = this.resultFilterComponent.getQueryFilters();

        // Additional options
        if (this.sortByColumn.value) {
            this.queryRequest.sortByColumn = this.sortByColumn.value;
        }
        if (this.sortDirection.value) {
            this.queryRequest.sortDescending = (this.sortDirection.value === 'DESC');
        }
        this.queryRequest.useAbsoluteValue = this.useAbsoluteValue.value;
        if (this.topNCount.value) {
            this.queryRequest.topNCount = Number.parseInt(this.topNCount.value);
        } else {
            this.queryRequest.topNCount = undefined;
        }
        if (this.reportDashboardComponentConfig.type === 'TEXT') {
            // Take it out at the end as text type components dont have a query request associated
            this.reportDashboardComponentConfig.queryRequest = undefined;
        }
        if (this.usePreset.value) {
            const selectedPresetOptionAndValues = [];
            this.selectedPresetOptionAndValuesGroups
                .forEach((group) => {
                    selectedPresetOptionAndValues.push(...group.optionAndValues);
                })
            const params = selectedPresetOptionAndValues
                .reduce((grouped, o) => {
                    let optionValue;
                    // if (o.option.multiChoice) {
                    //     if (o.value) {
                    //         optionValue = o.value.join(',');
                    //     }
                    // } else {
                    optionValue = o.value;
                    // }

                    if (moment.isMoment(o.value)) {
                        optionValue = o.value.format('YYYY-MM-DD');
                    }

                    grouped[o.option.name] = optionValue;
                    return grouped;
                }, {});
            this.queryRequest.presetConfig = {
                category: 'COMPONENT',
                type: this.presetDefinition.value.name,
                scope: this.presetDefinition.value.scope,
                displayMode: this.presetDefinition.value.displayMode,
                parameters: params,
            };
        } else {
            delete this.queryRequest.presetConfig;
        }
        this.reinitializeFieldDisplays();
        // Permissions
        if (this.reportDashboardPersistedConfig) {
            this.reportDashboardPersistedConfig.meta = this.reportDashboardPersistedConfig.meta || {} as any;
            this.reportDashboardPersistedConfig.meta.owner = this.owner.value;
            this.reportDashboardPersistedConfig.meta.collaborators = this.collaborators.value;
            this.reportDashboardPersistedConfig.meta.viewers = this.viewers.value;
        }
        if (this.reportDashboardMetricDefinition) {
            this.reportDashboardMetricDefinition.displayName = this.queryName.value;
            if (this.reportDashboardMetricDefinition.type === 'QUERY_BASED') {
                this.reportDashboardMetricDefinition.queryBased.queryType = this.queryType.value;
                this.reportDashboardMetricDefinition.queryBased.valueColumns = this.valueColumns.value;
                this.reportDashboardMetricDefinition.queryBased.fieldDisplays = this.reportDashboardComponentConfig.fieldDisplays || [];
                this.reportDashboardMetricDefinition.queryBased.sourceFilters = this.sourceFilterComponent.getQueryFilters();
                // this.reportDashboardMetricDefinition.useAbsoluteValue = this.useAbsoluteValue.value;
            } else if (this.reportDashboardMetricDefinition.type === 'PRESET_BASED') {
                this.reportDashboardMetricDefinition.queryBased.presetConfig = this.queryRequest.presetConfig;
                this.reportDashboardMetricDefinition.queryBased.presetConfig.category = 'METRIC';
            }
        }
        this.reportDashboardComponentConfig.conditionalRelevanceConfig.requirementType = this.conditionalityRequirementType.value;
    }

    reinitializeFieldDisplays() {
        if (this.isReportDashboardComponentConfig) {
            const fieldDisplays = this.reportDashboardComponentConfig.fieldDisplays || [];
            const allColumns = [...this.allAttributeDisplayColumns(), ...this.allValueDisplayColumns()];
            allColumns
                .forEach((col) => {
                    const foundFD = fieldDisplays
                        .find((fd) => {
                            return fd.field === col;
                        });
                    if (foundFD) {
                        const isComparison = this.reportDashboardComponentConfig.type === 'COMPARISON_TABLE';
                        if (!isComparison) {
                            foundFD.comparisonDisplay = undefined;
                        }
                    } else {
                        fieldDisplays.push({
                            field: col,
                            displayName: this.customerColumnAliases[col] || convertFromConstantToHuman(col),
                            amountUnit: 'AMOUNT',
                            amountDecimals: 2,
                            convertTo: 'NONE',
                            totalType: 'NONE'
                        } as ReportDashboardFieldDisplay);
                    }
                });
            this.reportDashboardComponentConfig.fieldDisplays = fieldDisplays
                .filter((fd) => {
                    return allColumns.includes(fd.field);
                })
                .sort((fd1, fd2) => {
                    const i1 = allColumns.indexOf(fd1.field);
                    const i2 = allColumns.indexOf(fd2.field);
                    return i1 - i2;
                })
                ;
        }
    }

    onTabIndexChange(index) {
        if (index === 3) {
            // This is the Display Tab. We need to refresh it
            this.reinitializeFieldDisplays();
            if ((this.reportDashboardComponentConfig.fieldDisplays || []).length > 0) {
                if (!this.selectedFieldDisplay) {
                    // Select first field display
                    this.selectedFieldDisplay = this.reportDashboardComponentConfig.fieldDisplays[0];
                    this.fieldDisplay.setValue(this.selectedFieldDisplay);
                    this.onFieldDisplaySelected(undefined);
                }
            }
        }
        this.queryFormGroup.updateValueAndValidity();
    }

    allAttributeDisplayColumns() {
        const columns = [];
        if (this.attributeColumn.value) {
            columns.push(this.attributeColumn.value);
        }
        if (this.attributeColumns.value) {
            columns.push(...this.attributeColumns.value);
        }
        if (this.pivotRowColumns.value) {
            columns.push(...this.pivotRowColumns.value);
        }
        if (this.pivotColColumns.value) {
            columns.push(...this.pivotColColumns.value);
        }
        return columns;
    }

    allValueDisplayColumns() {
        const columns = [];
        if (this.valueColumn.value) {
            columns.push(this.valueColumn.value);
        }
        if (this.valueColumns.value) {
            columns.push(...this.valueColumns.value);
        }
        return columns;
    }

    isAttributeColumn(column: string) {
        return this.allAttributeDisplayColumns().includes(column);
    }

    isValueColumn(column: string) {
        return this.allValueDisplayColumns().includes(column);
    }

    isDateColumn(column: string) {
        if (this.queryUsage.value !== 'DASHBOARD') {
            // We can only support this in dashboard mode.
            return false;
        }
        const foundCM = this.columnMeta
            .find((cm) => {
                return cm.columnName === column;
            });
        if (foundCM && foundCM.source === 'SYNTHETIC') {
            return false;
        }
        return column.toLowerCase().endsWith('_date');
    }

    isRunningTotalSupported(column: string): { isSupported: boolean, message?: string } {
        if (!this.queryFormGroup || !this.componentType) {
            // Not initialized yet so dont fail
            return {
                isSupported: true
            };
        }
        if (this.componentType.value === 'TABLE' || this.componentType.value === 'PIVOT') {
            const attributeColumns = (this.componentType.value === 'TABLE') ? this.attributeColumns.value : this.pivotRowColumns.value;
            if (attributeColumns && attributeColumns.length === 1) {
                const firstAttributeColumn = attributeColumns[0];
                const foundCM = this.columnMeta
                    .find((cm) => {
                        return cm.columnName === firstAttributeColumn;
                    });
                if (foundCM) {
                    if (foundCM.source !== 'SYNTHETIC' &&
                        (firstAttributeColumn.endsWith('_date') || firstAttributeColumn.endsWith('_tenor'))) {
                        return {
                            isSupported: true,
                        };
                    }
                }
            }
            let failureMessage;
            if (this.componentType.value === 'TABLE') {
                failureMessage = 'Running totals may only be used for Tables with a single attribute that is a date or tenor';
            } else {
                failureMessage = 'Running totals may only be used in Pivots with a single pivot row attribute that is a date or tenor';
            }
            return {
                isSupported: false,
                message: failureMessage
            };
        }
        return {
            isSupported: false,
            message: 'Running totals may only be used in tables or pivots'
        };
    }

    isHistoricalSeriesAllowed() {
        if (this.data.isMetricDefinition) {
            return false;
        }
        if (this.componentType.value === 'TABLE') {
            if (this.attributeColumns.value &&
                this.attributeColumns.value.includes('operating_date')) {
                return true;
            }
        } else if (this.componentType.value === 'PIVOT') {
            if ((this.pivotRowColumns.value &&
                this.pivotRowColumns.value.includes('operating_date')) ||
                (this.pivotColColumns.value &&
                    this.pivotColColumns.value.includes('operating_date'))) {
                return true;
            }
        } else if (this.componentType.value === 'CHART') {
            if ((this.chartType.value === 'COLUMN' || this.chartType.value === 'BAR')
                && this.attributeColumn.value === 'operating_date') {
                return true;
            }
        }
        if (this.presetDefinition.value) {
            const presetDefinition: ReportDashboardPresetDefinition = this.presetDefinition.value;
            if (presetDefinition.meta?.supportedFeatures?.historicalParams) {
                return true;
            }
        }
        return false;
    }

    getDialogReturnValue() {
        if (this.data.isMetricDefinition) {
            return this.reportDashboardMetricDefinition;
        } else if (this.isReportDashboardComponentConfig) {
            return this.reportDashboardComponentConfig;
        } else {
            return this.queryRequest;
        }
    }

    setAmountDecimalsOnFieldDisplay(fieldDisplay: ReportDashboardFieldDisplay, value) {
        fieldDisplay.amountDecimals = Number.parseInt(value);
    }

    openColumnChooserDialog(target: 'CHART_ATTRIBUTE' | 'CHART_VALUE') {
        let columns;

        if (target === 'CHART_ATTRIBUTE') {
            columns = [...this.availableAttributeColumns];
        } else if (target === 'CHART_VALUE') {
            columns = [...this.availableValueColumns];
        }

        const dialogRef = this.dialog.open(ReportDashboardColumnChooserDialogComponent, {
            width: '500px',
            height: '60vh',
            data: { columns }
        });

        dialogRef.afterClosed().subscribe({
            next: result => {
                if (result) {
                    if (target === 'CHART_ATTRIBUTE') {
                        this.attributeColumn.setValue(result.value);
                    } else if (target === 'CHART_VALUE') {
                        this.valueColumn.setValue(result.value);
                    }
                }
            }
        });
    }

    optionLabelToDisplayName(option: string): string {
        return convertFromConstantToHuman(option);
    }

    getAdjustedAvailableResultValueColumns() {
        const isComparison = this.reportDashboardComponentConfig.type === 'COMPARISON_TABLE';
        let availableResultValueColumns = this.availableValueColumns;
        if (isComparison) {
            availableResultValueColumns = this.availableValueColumns
                .reduce((aggregateItems, columnSelectItem) => {
                    ['curr', 'prev', 'diff']
                        .forEach((suffix) => {
                            aggregateItems.push({
                                label: `${columnSelectItem.label} (${convertFromHumanToCamel(suffix)})`,
                                value: `${columnSelectItem.value}_${suffix}`
                            });
                        });
                    return aggregateItems;
                }, []);
        }
        return availableResultValueColumns;
    }

    updateSourceQueryFilterColumnGroups() {
        this.sourceQueryFilterColumnGroups = [this.availableAttributeColumns, this.getAdjustedAvailableResultValueColumns()];
    }

    updateResultQueryFilterColumnGroups() {
        this.resultQueryFilterColumnGroups = [this.getAdjustedAvailableResultValueColumns()];
    }

    onAddConditionSet() {
        // const crs = [...this.reportDashboardComponentConfig.conditionalRelevanceConfig.conditionRequirements];
        // crs.push();
        this.reportDashboardComponentConfig.conditionalRelevanceConfig.conditionRequirements.push({
            conditions: []
        });
    }
    onFieldDisplaySelected(event) {
        this.selectedFieldDisplay = this.fieldDisplay.value;
        setTimeout(() => {
            this.bucketTenorChooserBar.value = this.selectedFieldDisplay.bucketTenors;
        }, 10);

    }
    onReverseBucketingChanged(event: MatCheckboxChange, selectedFieldDisplay: ReportDashboardFieldDisplay) {
        selectedFieldDisplay.isReverseBucketing = event.checked;
    }

    isQueryUsageDisabled(usage: ReportDashboardQueryUsage, componentType: string,): boolean {
        let isDisabled = true;
        switch (usage) {
            case 'DASHBOARD':
                isDisabled = componentType !== 'TABLE' && componentType !== 'COMPARISON_TABLE';
            case 'INVENTORY':
                isDisabled = !(componentType === 'TABLE');
            case 'INVESTIGATION':
                isDisabled = !(componentType === 'TABLE' || componentType === 'COMPARISON_TABLE');
            case 'DOWNLOAD':
                isDisabled = !(componentType === 'TABLE' || componentType === 'COMPARISON_TABLE');
        }
        const presetDefinition: ReportDashboardPresetDefinition = this.presetDefinition.value;

        if (this.usePreset.value && presetDefinition) {
            const additionalQueryUsages = presetDefinition.meta?.supportedFeatures?.additionalQueryUsages;
            if (additionalQueryUsages) {
                if (!additionalQueryUsages.includes(usage) && presetDefinition.usage !== usage) {
                    isDisabled = true;
                }
            } else {
                isDisabled = presetDefinition.usage !== usage;
            }
        }
        return isDisabled;
    }

    presetOptionFXFlex(optionAndValue: PresetOptionAndValue, defaultValue: string) {
        const width = optionAndValue.option.fieldWidth || defaultValue;
        return `1 1 ${width}`;
    }
}


